// http://playable.dev.com:8067/?doc=playsmart/playturbo%2fhandler%2fplaysmart%2fproject.go
import request from '@ps/utils/request'
import { cookRequestParams } from '@/common/request'
import store from '@ps/store'

export function createPSProject(data) {
  return request({
    url: `/ps/project/create`,
    method: 'post',
    data,
  })
}

export function relateProductPsProject(data) {
  return request({
    url: `/ps/project/relate-product`,
    method: 'post',
    data,
  })
}

export function createPSProjectByPsd(data) {
  return request({
    url: `/ps/project/create-from-psd`,
    method: 'post',
    data,
  })
}

export function getPSProjectInfo(params) {
  return request({
    url: `/ps/project/info`,
    method: 'get',
    params,
  })
}

export function getPSProjectList(params) {
  return request({
    url: `/ps/project/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function deletePSProject(data) {
  return request({
    url: `/ps/project/delete?id=${data.id}`,
    method: 'post',
    data: {},
  })
}

export function packPsProject(data) {
  return request({
    url: `/ps/project/pack`,
    method: 'post',
    data,
    timeout: 120000,
  })
}

export function savePsProject(data) {
  if (!data.material_event) {
    data.material_event = store.state.workspace.project.materialEvent
  }
  return request({
    url: `/ps/project/save?id=${data.id}`,
    method: 'post',
    data,
  })
}

export function getPsProjectChannels(params) {
  return request({
    url: `/ps/project/channels`,
    method: 'get',
    params,
  })
}

export function getPsDownloadStatus(params) {
  return request({
    url: `/ps/project/download-check`,
    method: 'get',
    params,
  })
}

export function getPsProjectPreview(params) {
  return request({
    url: `/ps/project/preview`,
    method: 'get',
    params,
  })
}

export function myTemplatePreview(params) {
  return request({
    url: `/ps/project/preview`,
    method: 'get',
    params,
  })
}

export function getPsTemplate(params) {
  return request({
    url: `/ps/template/list`,
    method: 'get',
    params,
  })
}

export function getPsProjectDownloadCount(params) {
  return request({
    url: `/ps/project/download-count`,
    method: 'get',
    params,
  })
}

export function resetDemoProject(params) {
  return request({
    url: `/ps/project/reset-demo`,
    method: 'post',
    params,
  })
}

export function downloadPSPlayable(params) {
  return request({
    url: `/ps/project/download`,
    method: 'get',
    params,
  })
}

export function getPsProjectHistoryName(params) {
  return request({
    url: `/ps/project/creatives`,
    method: 'get',
    params,
  })
}
